import { Link } from "react-router-dom";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { Shield } from "lucide-react";

const AdminAccessButton = () => {
  const { isAuthenticated, isLoading } = useAdminAuth();

  // Ne rien afficher pendant le chargement ou si non authentifié/admin
  if (isLoading || !isAuthenticated) {
    return null;
  }

  return (
    <Link
      to="/admin/dashboard"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9998] bg-[hsl(145,35%,35%)] hover:bg-[hsl(145,35%,30%)] text-white px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 font-medium text-sm sm:text-base"
      title="Accéder à l'espace administrateur"
    >
      <Shield className="h-4 w-4 sm:h-5 sm:w-5" />
      <span>Espace Admin</span>
    </Link>
  );
};

export default AdminAccessButton;
